export enum Filters {
  PREPAID_NATIONAL = 'PREPAID_NATIONAL',
  ROOM_ONLY = 'ROOM_ONLY',
  PREPAID_INTERNATIONAL = 'PREPAID_INTERNATIONAL',
  PREPAID_USD = 'PREPAID_USD',
  PREPAID = 'PREPAID',
  PAY_AT_DESTINATION = 'PAY_AT_DESTINATION',
  REFUNDABLE = 'REFUNDABLE',
  NOT_REFUNDABLE = 'NOT_REFUNDABLE',
  ALL_INCLUSIVE = 'ALL_INCLUSIVE',
  HALF_BOARD = 'HALF_BOARD',
  FULL_BOARD = 'FULL_BOARD',
  BREAKFAST = 'BREAKFAST',
  DISNEY_MEALPLANS = 'DISNEY_MEALPLANS',
  DISNEY_TICKETS = 'DISNEY_TICKETS',
  DISNEY_ROOM_ONLY = 'DISNEY_ROOM_ONLY',
  CONTRATO_DIRECTO = 'CONTRATO_DIRECTO',
}
